import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Rating, Excerpt } from 'audamatic-ui';
import Text from '@text';
import './styles/styles.scss';

class Review extends Component {
  /**
   * Return a Date object
   * based on date comming from back end
   *
   * @param str
   * @returns {Date}
   */
  getDate = (date) => {
    // if myDate is already instance of date return that
    let dateInstance = '';
    if (date instanceof Date) {
      dateInstance = date;
    } else {
      /*
       * it is probably a string of this format
       * Thu Dec 06 10:56:19 CET 2018
       * const [Thu, Dec, 06, 10:56:19, CET, 2018] = myDate
       */
      const dateChunks = date.split(' ');
      const month = dateChunks[1];
      const day = dateChunks[2];
      const year = dateChunks[5];

      dateInstance = new Date(`${day} ${month} ${year}`);
    }


    return dateInstance.toLocaleDateString('nl', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  render() {
    const { review = {}, dataTestId } = this.props;

    const {
      authorFirstName,
      creationDate,
      rating,
      title,
      content = '',
      status,
    } = review;

    const name = authorFirstName || null;
    const date =  creationDate ? this.getDate(creationDate) : null;
    const pending = (!!status && status.toLowerCase().includes('new')) || null;
    const rejected = (!!status && status.toLowerCase().includes('rejected')) || null;

    return (
      <>
        <div className="product-review" data-test-id={dataTestId}>
          <div className="title">&lsquo;{title}&rsquo;</div>
          <div className="meta">
            <Rating rating={rating} />
            <div className="date">
              <span>|</span>
              <span>
                <Text replacements={{ name, date }}>comp.reviews.review.subtitle</Text>
              </span>
            </div>
          </div>
          <Excerpt
            text={content}
            maxLines={8}
            label1={<Text>common.link.readmore</Text>}
            label2={<Text>common.link.readless</Text>}
          />
        </div>
        {pending && (
          <div className="reviews-message">
            <Text>comp.reviews.add-rating.thank-you-message</Text>
          </div>
        )}
        {rejected && (
          <div className="reviews-message">
            <Text>comp.reviews.review.rejected</Text>
          </div>
        )}
      </>
    );
  }
}

Review.propTypes = {
  review: PropTypes.object,
  dataTestId: PropTypes.string,
};

export default Review;
